import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material/utils";
const FolderIcon = createSvgIcon(/* @__PURE__ */ jsx("svg", { width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("g", { id: "prefix__icons/folder", children: /* @__PURE__ */ jsx("path", { id: "prefix__icon", d: "M13.4 6H5.6C4.17 6 3.013 7.18125 3.013 8.625L3 24.375C3 25.8188 4.17 27 5.6 27H26.4C27.83 27 29 25.8188 29 24.375V11.25C29 9.80625 27.83 8.625 26.4 8.625H16L13.4 6Z" }) }) }), "FolderIcon");
export {
  FolderIcon
};
